
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Mail, Bell, Smartphone } from "lucide-react";

interface NotificationChannelSelectorProps {
  channels: string[];
  onChange: (channels: string[]) => void;
  disabled?: boolean;
}

const channelOptions = [
  {
    id: 'in_app',
    label: 'التنبيهات الداخلية',
    icon: Bell,
    color: 'bg-blue-100 text-blue-800'
  },
  {
    id: 'email',
    label: 'البريد الإلكتروني',
    icon: Mail,
    color: 'bg-green-100 text-green-800'
  },
  {
    id: 'sms',
    label: 'الرسائل النصية',
    icon: Smartphone,
    color: 'bg-orange-100 text-orange-800',
    disabled: true // SMS not implemented yet
  }
];

export const NotificationChannelSelector = ({ 
  channels, 
  onChange, 
  disabled 
}: NotificationChannelSelectorProps) => {
  const handleChannelChange = (channelId: string, checked: boolean) => {
    if (checked) {
      onChange([...channels, channelId]);
    } else {
      onChange(channels.filter(c => c !== channelId));
    }
  };

  return (
    <div className="space-y-3">
      <Label className="text-sm font-medium">قنوات الإرسال</Label>
      <div className="flex flex-wrap gap-2">
        {channelOptions.map((option) => {
          const Icon = option.icon;
          const isChecked = channels.includes(option.id);
          const isDisabled = disabled || option.disabled;
          
          return (
            <div
              key={option.id}
              className={`flex items-center gap-2 p-2 border rounded-lg transition-colors ${
                isChecked ? 'bg-blue-50 border-blue-200' : 'hover:bg-gray-50'
              } ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
              onClick={() => !isDisabled && handleChannelChange(option.id, !isChecked)}
            >
              <Checkbox
                id={option.id}
                checked={isChecked}
                onCheckedChange={(checked) => !isDisabled && handleChannelChange(option.id, !!checked)}
                disabled={isDisabled}
              />
              <Icon className="h-4 w-4" />
              <Label htmlFor={option.id} className="text-sm cursor-pointer">
                {option.label}
              </Label>
              {option.disabled && (
                <Badge variant="secondary" className="text-xs">قريباً</Badge>
              )}
            </div>
          );
        })}
      </div>
      {channels.length === 0 && (
        <p className="text-sm text-gray-500">يرجى اختيار قناة واحدة على الأقل</p>
      )}
    </div>
  );
};
